import request from "@/plugins/axiosRequest";

const url = "/api/dashboard/v1/apps";
const urlRequest = "/api/dashboard/v1/request_logs";
const urlCallback = "/api/dashboard/v1/callback_logs";

export function fetchList(query) {
  return request({
    url: url,
    method: "get",
    params: query
  });
}

export function fetchApp(id) {
  return request({
    url: url,
    method: "get",
    params: { id }
  });
}

export function postNewApp(data) {
  return request({
    url: url,
    method: "post",
    data
  });
}

export function deleteApp(id) {
  return request({
    url: `${url}/${id}`,
    method: "delete"
  });
}

export function updateApp(data) {
  return request({
    url: `${url}/${data.id}`,
    method: "PUT",
    data
  });
}

export function fetchListRequests(query) {
  return request({
    url: urlRequest,
    method: "get",
    params: query
  });
}

export function fetchListCallbacks(query) {
  return request({
    url: urlCallback,
    method: "get",
    params: query
  });
}